var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"record"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('meeting.recording')))])])}
var staticRenderFns = []

export { render, staticRenderFns }